import dayjs from "dayjs";
import { decrypt } from "./cryptoUtil";

const AUTH_KEY = "authData";
const SESSION_TIMESTAMP = "sessionTimestamp";

export const setAuthData = (data) => {
  if (typeof window === "undefined" || !data) return;

  const authData = {
    token: data?.token || null, // raw token
    userId: data?.userId || null,
    rawResponse: data, // keep original response
  };

  window.sessionStorage.setItem(AUTH_KEY, JSON.stringify(authData));
};

export const getAuthData = () => {
  if (typeof window === "undefined") return null; //  SSR safe

  const stored = window.sessionStorage.getItem(AUTH_KEY);
  return stored ? JSON.parse(stored) : null;
};

export const getAuthMemberData = async () => {
  if (typeof window === "undefined") return null; //  SSR safe
  const stored = getAuthData();

  const encryptedData = stored?.rawResponse?.memberDetails;

  if (encryptedData) {
    const decryptedString = await decrypt(encryptedData);

    const params = new URLSearchParams(decryptedString);
    const userObj = {};
    for (let [key, value] of params.entries()) {
      userObj[key] = decodeURIComponent(value.replace(/\+/g, " "));
    }

    return userObj;
  } else {
    return null;
  }
};

export const clearAuthData = () => {
  if (typeof window === "undefined") return; //  SSR safe

  window.sessionStorage.removeItem(AUTH_KEY);
};

export const setSessionTimeStamp = () => {
  if (typeof window === "undefined") return; //  SSR safe
  try {
    // Always stringify to store as a string
    const timestampSec = dayjs().unix();
    window.localStorage.setItem(SESSION_TIMESTAMP, JSON.stringify(timestampSec));
  } catch (error) {
    console.log("Error setting timeStamp:", error);
  }
};

export const isSessionExpired = () => {
  if (typeof window === "undefined") return false; //  SSR safe
  try {
    const loginTime = window.localStorage.getItem(SESSION_TIMESTAMP);
    if (!loginTime) return true; // no timestamp > expired

    const currentTime = dayjs().unix(); // current time in seconds
    const diffInMinutes = (currentTime - parseInt(loginTime, 10)) / 60;

    return diffInMinutes > 30; // expired if > 30 mins
  } catch (error) {
    console.log("Error in session calculation:", error);
    return true; // fail-safe → consider expired
  }
};

export const clearSessionTimeStamp = () => {
  if (typeof window === "undefined") return; //  SSR safe

  window.localStorage.removeItem(SESSION_TIMESTAMP);
};

export const isUserunactivefor7days = () => {
  if (typeof window === "undefined") return false; //  SSR safe
  try {
    const loginTime = window.localStorage.getItem(SESSION_TIMESTAMP);
    if (!loginTime) return true; // no timestamp > expired

    const currentTime = dayjs().unix(); // current time in seconds
    const diffInMinutes = (currentTime - parseInt(loginTime, 10)) / 60;

    return diffInMinutes > 30; // expired if > 30 mins
  } catch (error) {
    console.log("Error in session calculation:", error);
    return true; // fail-safe → consider expired
  }
};

export const isUserInactiveFor7Days = () => {
  if (typeof window === "undefined") return false; //  SSR safe
  try {
    const loginTime = window.localStorage.getItem(SESSION_TIMESTAMP);
    if (!loginTime) return true; // no timestamp → expired

    const currentTime = dayjs().unix(); // current time in seconds
    const diffInDays = (currentTime - parseInt(loginTime, 10)) / (60 * 60 * 24);

    return diffInDays >= 7; // expired if inactive for 7 or more days
  } catch (error) {
    console.log("Error in inactivity calculation:", error);
    return true; // fail-safe → consider inactive
  }
};
